import translations from 'utils/Languages'

type Translations = typeof translations

type TranslationKey = keyof Translations // "testTemplate"

type FunctionKeys<T> = {
    [K in keyof T]: T[K] extends (...args: any) => any ? K : never
}[keyof T]

type TranslationArgs<
    K extends TranslationKey,
    L extends FunctionKeys<Translations[K]>
> =
    // @ts-expect-error type is assignable
    Parameters<Translations[K][L]>[0]

function t<K extends keyof Translations>(
    key: K,
    args?: TranslationArgs<K, FunctionKeys<Translations[K]>>
): string {
    const locale = 'NL' // getLocale()

    let translation = translations[key][locale]

    if (typeof translation === 'function') {
        return translation(args)
    }

    return translation
}

const allowedLocales = ['nl', 'en'] as const

export function getLocale() {
    return 'nl'
    // eslint-disable-next-line no-unreachable
    let browserLocale =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        'en'
    if (browserLocale === 'en-US') {
        browserLocale = 'en'
    }

    const normalizedLocale = allowedLocales.includes(browserLocale as 'nl' | 'en') ?
        (browserLocale as 'nl' | 'en') :
        'nl'

    return normalizedLocale
}

export default t
